import styled from 'styled-components'
import { ANATOMY_V2_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const AnatomyV2RateYourselfStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin: 24px 0;
  `,

  Image: styled.img`
    width: 100%;
    border-radius: 16px;
    object-fit: cover;
    margin-bottom: 24px;
  `,

  RatingRow: styled.div`
    display: flex;
    gap: 5px;
    margin-top: auto;
  `,

  RatingButton: styled.button<{ $isSelected?: boolean }>`
    flex: 1;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $isSelected }) =>
      $isSelected ? ANATOMY_V2_ACCENT_COLOR : '#dfdfdf'};
    border: none;
    border-radius: 10px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: ${({ $isSelected }) => ($isSelected ? COLORS.WHITE : '#17202a')};
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${({ $isSelected }) =>
        $isSelected ? ANATOMY_V2_ACCENT_COLOR : '#dfdfdf'};
    }
  `,

  ScaleRow: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
  `,

  ScaleLabel: styled.span`
    color: ${COLORS.BLACK};
    font-family: 'Poppins', sans-serif;
    font-size: 10px;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
  `,

  ScaleLine: styled.div`
    flex: 1;
    display: flex;
    align-items: center;
  `,
}
